import { Model as BaseModel } from '@iwavesmedia/json-api-query';
export default class Model extends BaseModel {
    constructor() {
        super(...arguments);
        this._fromResource = null;
    }
    // Define a base url for a REST API
    baseURL() {
        return route('api.base');
    }
    // Implement a default request method
    request(config) {
        return this.$http.request(config);
    }
}
